module.exports = "Page not found.\n\n<Button primary element={Link} to=\"/\">Home</Button>\n"